import React from 'react';
import { Smartphone } from 'lucide-react';

export default function PushPrefToggle({ api }) {
  const [on, setOn] = React.useState(null);
  const touched = React.useRef(false);
  React.useEffect(() => { api.get('/api/push/preferences').then((r) => { if (!touched.current) setOn(r.data.announcements); }).catch(() => {}); }, [api]);
  if (on === null) return null;
  const toggle = async () => {
    touched.current = true;
    const next = !on;
    setOn(next);
    try { await api.put('/api/push/preferences', { announcements: next }); } catch { setOn(!next); }
  };
  return (
    <div className="px-4 py-2 border-t border-neutral-200 flex items-center gap-2" data-testid="push-pref-row">
      <Smartphone className="w-3.5 h-3.5 text-neutral-400" />
      <span className="flex-1 text-[11px] text-neutral-600">Announcements & greetings on my phone</span>
      <button type="button" role="switch" aria-checked={on} onClick={toggle} data-testid="push-pref-announcements-toggle"
        className={`relative w-9 h-5 rounded-full transition-colors ${on ? 'bg-emerald-500' : 'bg-neutral-300'}`}>
        <span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white shadow transition-transform ${on ? 'translate-x-4' : ''}`} />
      </button>
    </div>
  );
}
